import packageJson from './package.json.js';

const setVersionOnWindow = () => {
  window.COUPON_CALLOUT_COMPONENT_VERSION = packageJson.version;
};

export { setVersionOnWindow };
//# sourceMappingURL=src-hooks-useSetVersionOnWindow.js.map
